import getCoords from '../../../../../../../../_dev/frontend/js/commonFunctions/getCoords';

const contentRowIsSticky = () => {
    const header = document.querySelector('.Header');
    const stickyElement = document.querySelector('.Content__row.--Is-sticky');
    const productsList = document.querySelector('.Products-list');

    document.addEventListener('DOMContentLoaded', () => {
        if (header && stickyElement && productsList) {
            const headerHeight = header.offsetHeight;
            const headerMargin = 16;
            const windowWidth = window.innerWidth;
            const stickyElementCoords = getCoords(stickyElement);
            const stickyElementHeight = stickyElement.offsetHeight;
            const stickyElementParent = stickyElement.parentElement;
            const productsListCoords = getCoords(productsList);
            const startPoint = stickyElementCoords.top - (headerHeight + headerMargin);
            const endlessPoint = productsListCoords.bottom;
            

            document.addEventListener('scroll', () => {
                if (window.scrollY >= startPoint && window.scrollY < endlessPoint - 200) {
                    stickyElement.style.position = 'fixed';
                    stickyElement.style.top = `${headerHeight + headerMargin}px`;
                    stickyElementParent.style.height = `${stickyElementHeight}px`;
                } else {
                    stickyElement.style.position = '';
                    stickyElement.style.top = '';
                    stickyElementParent.style.height = '';
                }
            });
        }
    });
};

export default contentRowIsSticky;
